<template>
  <div>
    <div class="page" v-if="showStep === 0">
      <el-divider></el-divider>
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="queryFormData"
        :columns="formColumn"
        :rules="baseRules"
        :isQueryPanel="true"
        @refreshDistrict="refreshDistrict"
        @changeCompany="changeCompany"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchBtnClick"
      ></SiruiSearch>

      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="tableLoading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="columnListDefault"
          :showToolbar="true"
          :valid-config="{ autoPos: true, message: 'inline' }"
          @chooseClick="chooseClick"
          @dblclickEvent="dblclickEvent"
          :cellClick="cellClickEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column
            v-for="(item, index) in columnListDefault"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'applicationNo'"
                ><div style="color: blue">
                  {{ row.applicationNo }}
                </div></template
              >
              <template v-else-if="item.field == 'newSelfUseFlag'"
                ><div>
                  {{
                    row.type == '04'
                      ? getYesOrNoLabel(row.newSelfUseFlag)
                      : getYesOrNoLabel(row.selfUseFlag)
                  }}
                </div></template
              >
              <template v-else-if="item.field == 'type'"
                ><div>
                  {{ getStateLabel(row.type, 'search-type') }}
                </div></template
              >
              <template v-else-if="item.field == 'auditStatus'"
                ><div>
                  {{ getStateLabel(row.auditStatus, 'audit-state') }}
                </div></template
              >
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
  </div>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { baseRules } from './rules/rules.js'; // 校验规则
  import mixin from './mixins/mixin';
  import translateMinxin from '../mixin/translateMinxin';
  import API from '@/api/property/spaceAssets';
  import { querySpaceApproval } from '@/api/property/model';

  export default {
    name: 'spaceAudit',
    mixins: [mixin, translateMinxin],
    components: {
      SiruiSearch,
    },
    computed: {},
    data() {
      return {
        baseRules: baseRules,
        companyList: [],
        showStep: 0, //0 为列表页，2为详情页
        menuButtonList: [],
        tableData: [], // 表格数据
        queryFormData: JSON.parse(JSON.stringify(querySpaceApproval)),
        exportQuery: {},
        showAddPropertyDialog: false,
        showAddAreaDilaog: false,
        showAddUnitDialog: false,
        exportLoading: false,
        tableLoading: false,
        query: {
          companyCode: '',
        },
        listData: [],
        treeData: [],
        multipleSelection: [],
      };
    },
    watch: {
      'queryFormData.spaceCompanyNo': {
        handler: function (newVal) {
          console.log(newVal);
          this.querySpaceTree();
        },
        deep: true,
      },
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.queryFormData.spaceCompanyNo = this.userInfo.companyCode;
      this.getData();
      this.getButtonList();
    },
    activated() {
      this.multipleSelection = [];
      this.searchBtnClick();
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      chooseClick(value) {
        this[value]();
      },

      changeCompany(value) {
        console.log('changeCompany', value);
      },

      //双击事件
      dblclickEvent(value) {
        console.log('dblclickEvent', value);
      },
      //搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.assetsList = [];
        this.queryFormData.spaceCompanyNo = this.userInfo.companyCode;
        this.getData();
      },
      handleSizeChange() {
        this.getData();
      },
      handleCurrentChange() {
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      ///审核
      auditClick() {
        console.log('auditClick');
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();
        console.log('auditClick', this.multipleSelection);
        if (this.multipleSelection.length == 0) {
          this.$message.error('请选择数据');
          return;
        }
        if (this.multipleSelection.length > 1) {
          this.$message.error('请选择一条数据');
          return;
        }
        if (this.multipleSelection[0].auditStatus != '01') {
          this.$message.error('该状态的数据不支持审核，请核实。');
          return;
        }
        // this.showStep = 1;
        this.$router.push({
          path: '/property/spaceAuditDetail',
          name: 'spaceAuditDetail',
          meta: {
            keepAlive: true,
            title: '审核详情',
          },
          query: {
            id: this.multipleSelection[0].id,
            type: this.multipleSelection[0].type,
            isAudit: true,
          },
        });
      },
      search() {},
      //点击单元格的时候 根据不同需求判断改行是否能开启编辑
      cellClickEvent(val) {
        console.log('cellClick', val, val.row.partnerType, val.columnIndex);
        if (val.columnIndex == 1) {
          //跳转到详情页
          // this.$store.dispatch('tagsView/delView', {
          //   path: '/property/spaceAudit',
          //   name: 'spaceAudit',
          //   meta: {
          //     keepAlive: false,
          //     title: '',
          //   },
          // });
          this.$router.push({
            path: '/property/spaceAuditDetail',
            query: {
              id: val.row.id,
              type: val.row.type,
              isAudit: false,
            },
          });
        }
      },
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.queryFormData.pageNum = pageNum;
        this.queryFormData.pageSize = pageSize;
        this.tableLoading = true;
        this.$axios.post(API.SPACE_APPROVAL, this.queryFormData).then((res) => {
          this.tableLoading = false;
          if (res.data.code == 0) {
            this.$refs.siruiTable.setPageTotal(parseInt(res.data.data.total));
            this.tableData = res.data.data.records;
            var str = JSON.stringify(this.queryFormData);
            this.exportQuery = JSON.parse(str);
          }
        });
      },
      //获取公司信息
      getCompany() {
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code == 0) {
            console.log('getCompany', res.data.data.personCompanyInfo);
            let arr = res.data.data.personCompanyInfo.map((item) => {
              return {
                key: item.personCompanyName,
                value: item.personCompanyCode,
                label: item.personCompanyName,
              };
            });
            this.companyList.push(...arr);
          }
        });
      },
      //获取tree
      querySpaceTree() {
        if (this.queryFormData.spaceCompanyNo == '') {
          return;
        }
        this.$axios.get(API.SPACE, { companyNo: this.queryFormData.spaceCompanyNo }).then((res) => {
          console.log('querySpaceTree', res);
          if (res.data.code == '0') {
            this.changeListToTree(res.data.data);
            this.initFormColumn();
          }
        });
      },
      //将集合转为树形结构
      changeListToTree(value) {
        this.listData = value;
        this.treeData = [];
        this.tree_init(value, this.treeData);
      },
      tree_init(data, arr) {
        data.forEach((ele) => {
          if (!ele.parentId) {
            arr.push({
              id: ele.id,
              label: ele.name,
              type: ele.type,
              value: ele.id,
              leaseStatus: ele.leaseStatus,
              leafFlag: ele.leafFlag,
              area: ele.area,
              spaceNo: ele.spaceNo,
              selfUseFlag: ele.selfUseFlag,
              children: [],
            });
          } else {
            this.tree(ele, arr);
          }
        });
        console.log('changeListToTree', arr);
      },
      tree(data, arr) {
        arr.forEach((ele) => {
          if (parseInt(ele.id) === data.parentId) {
            ele.children.push({
              id: data.id,
              label: data.name,
              type: data.type,
              value: data.id,
              leaseStatus: data.leaseStatus,
              leafFlag: data.leafFlag,
              area: data.area,
              spaceNo: data.spaceNo,
              selfUseFlag: data.selfUseFlag,
              children: [],
            });
          } else {
            this.tree(data, ele.children);
          }
        });
      },
      //导出
      exportExcel() {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据');
          return;
        }
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();
        var param = {};
        if (this.multipleSelection.length > 0) {
          param.ids = this.multipleSelection.map((item) => item.id);
          param.spaceCompanyNo = this.exportQuery.spaceCompanyNo;
        } else {
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          this.exportQuery.pageNum = pageNum;
          this.exportQuery.pageSize = pageSize;
          param = this.exportQuery;
        }
        this.exportLoading = true;
        this.$axios.post(API.SPACE_APPROVAL_EXPORT, param).then((res) => {
          this.exportLoading = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    height: 100%;
    top: 0;
    .mytable-style .vxe-body--column.col-orange {
      background-color: #f60;
      color: #fff;
    }
    .page-row {
      margin-top: 20px;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }
    .reset {
      border-width: 0px;
      width: 51px;
      height: 28px;
      text-align: center;
      background: inherit;
      background-color: rgba(235, 243, 254, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(205, 217, 230, 1);
      border-radius: 4px;
      box-shadow: none;
      color: #768696;
      padding: 0 0 0 0;
    }
    ::v-deep .sirui-table .vxe-toolbar[data-v-3c6ed471] {
      margin-top: 0px;
    }
  }
</style>
